import { Outlet } from 'react-router';

import Header from '@cartwhl/ui/layout/Header';
import { useModal } from 'modals';

import Footer from './Footer';
import GridOverlay from './GridOverlay';

export default function Layout() {
  const { open } = useModal();

  return (
    <div className="bg-primary flex min-h-screen flex-col">
      <GridOverlay />
      <Header
        onApiAccessClick={() =>
          open('ENTERPRISE_CONTACT', { reason: 'request_api_access' })
        }
        onComingSoonClick={(excitedAbout?: string) => open('NOTIFY_ME', { excitedAbout })}
      />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
